// extracted by mini-css-extract-plugin
export default {"headerTitle":"entityTitle_headerTitle__6gGLH","deletedLabel":"entityTitle_deletedLabel__AAHlN","header":"entityTitle_header__hW4i7"};